import { DeleteDemComponent } from './../delete-dem/delete-dem.component';
import { DemService } from './../../../../services/demService/dem.service';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MapServiceService } from 'src/app/modules/map/services/Map-service/map-service.service';
import { SideNavService } from 'src/app/modules/map/services/sidenav/side-nav.service';
import { HttpClient } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-dem-detail',
  templateUrl: './dem-detail.component.html',
  styleUrls: ['./dem-detail.component.css']
})
export class DemDetailComponent implements OnInit {
  demObject: any
  loading = false;
  deleteTip = '<span>Delete this feature.</span>';
  closeRight =
    '<span><strong>Close</strong><p>Clear map selection(s) and close panel</p></span>';
  myOptions13 = {
    showDelay: 500,
    'tooltip-class': 'new-tooltip-class12',
  };
  myOptions15 = {
    showDelay: 500,
    'tooltip-class': 'new-tooltip-class15',
  };
  myDelete = {
    showDelay: 500,
    'tooltip-class': 'new-tooltip-class14',
  };
  constructor(
    public mapService: MapServiceService,
    private sideNavService: SideNavService,
    public demService: DemService,
    private dialog: MatDialog,
    private http: HttpClient,
    private spinner: NgxSpinnerService,
  ) { }

  ngOnInit(): void {
    this.demObject = this.demService.demData
  }

  clickToZoom() {
    const source = this.mapService.DEMLayer.getSource();
    const features = source.getFeatures();
    for (let i = 0; i < features.length; i++) {
      if (features[i].get('number') === this.demObject.id) {
        const extent = features[i].getGeometry().getExtent();
        this.mapService.mapLayer
          .getView()
          .fit(extent, this.mapService.mapLayer.getSize());
      }
    }
  }

  goBack() {
    this.sideNavService.isLoadedFeature('Featuresdasda');
    if (this.mapService.result) {
      this.mapService.result.getSource().clear();
    }
    this.sideNavService.maintainHistory();
  }
  closeRightpanel() {
    this.sideNavService.closeRightSideNav();
    this.demService.selectedId = '00'
    this.demService.setRefreshDem('res');
  }



  deleteDEM (id: any) {
    this.dialog.open(DeleteDemComponent, {
      data: {
        id: id,
      },
    });
  }

  downloadTiffFile(fileName: any): void {
      this.spinner.show()
      const url = `${this.sideNavService.downloadFileUrl}/media/dem/${fileName}`
      this.http.get(url, { responseType: 'blob' }).subscribe((res: Blob) => {
        this.loading = false;
        const link = document.createElement('a');
        link.href = URL.createObjectURL(res);
        link.download = `${fileName}`;
        link.click();
        this.spinner.hide()
      });
  }

}
